import React, { useState, useEffect } from "react";

import UnsubscribeModal from "../components/UnsubscribeModal";
import Form from "../components/Form";
import { sendPostRequest, formatPhoneNumber } from "../utils";

// TODO: Update this URL with your POS supplier's online ordering platform URL
const ONLINE_ORDER_URL = "https://your-pos-supplier-url.com";

const Subscribe = () => {
  const [inputs, setInputs] = useState({
    city: "",
    name: "",
    phone_number: "",
    postal_code: "",
    quantity: "",
    email: "",
    address: "",
    number: "",
    apartment: "",
    accept_sms_notification: false,
    accept_email_notification: false,
  });
  const [error, setError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [showUnsubscribeModal, setShowUnsubscribeModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  const doShowUnsubscribeModal = (value) => {
    setShowUnsubscribeModal(value);
  };

  const { quantity } = inputs;

  const handleChange = (event) => {
    const name = event.target.name;
    const value =
      name === "accept_sms_notification" || name === "accept_email_notification"
        ? event.target.checked
        : event.target.value;

    if (name === "phone_number") {
      if (value && !/^[0-9]+$/.test(value)) return;
      if (!/^\d{10}$/.test(Number(value)) && !phoneNumberError) {
        setPhoneNumberError("Numéro de téléphone invalide");
      } else if (/^\d{10}$/.test(Number(value)) && phoneNumberError) {
        setPhoneNumberError("");
      }
    }

    setInputs((values) => ({ ...values, [name]: value }));
  };

  const doCheckOut = async (userId) => {
    const res = await sendPostRequest("create-checkout-session", {
      lookup_key: String(quantity),
      user_info: {
        ...inputs,
        phone_number: formatPhoneNumber(inputs.phone_number),
      },
      userId,
    });

    const body = await res.json();
    if (body?.url) {
      window.location.href = body.url;
    }

    if (body?.errMessage) setError(body.errMessage);
  };

  const submitForm = (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    sendPostRequest("subscribe", {
      ...inputs,
      phone_number: formatPhoneNumber(inputs.phone_number),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data?.userId) doCheckOut(data.userId);
        if (data?.errMessage) {
          setError(data.errMessage);
          setIsSubmitting(false);
        }
      });
  };

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);

      const hasSeenPrompt = localStorage.getItem("pwa-prompt-dismissed");
      if (!hasSeenPrompt) {
        setShowInstallPrompt(true);
      }
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === "accepted") {
      console.log("PWA installed");
    }

    setDeferredPrompt(null);
    setShowInstallPrompt(false);
  };

  const handleDismissInstall = () => {
    setShowInstallPrompt(false);
    localStorage.setItem("pwa-prompt-dismissed", "true");
  };

  const handleOrderClick = () => {
    window.location.href = ONLINE_ORDER_URL;
  };

  return (
    <>
      {showUnsubscribeModal ? (
        <UnsubscribeModal
          open={showUnsubscribeModal}
          handleClose={() => doShowUnsubscribeModal(false)}
        />
      ) : null}

      <div
        className="relative overflow-y-auto px-10 py-5 bg-slate-200 min-h-screen flex justify-center flex-col bg-contain sm:bg-cover bg-repeat sm:bg-no-repeat"
        style={{
          backgroundImage: "url('/bagels_bg_img.jpg')",
        }}
      >
        {isSubmitting && <div id="cover-spin"></div>}

        <div>
          <div className="bagels__container bg-transparent lg:max-w-4xl xl:max-w-5xl md:max-w-3xl md:mx-auto md:w-1/2 w-full flex flex-col">
            <div className="bagels-logo w-full flex justify-center">
              <div className="bagels-logo__container p-6 md:px-14">
                <img
                  src="/logo_brt_couleur.png"
                  alt="bagels"
                  className="rounded-sm max-h-[350px]"
                  style={{filter: 'drop-shadow(1px 1px 4px rgba(255, 255, 255, 0.8))'}}
                />
              </div>
            </div>
            <div className="bagels-form lg:px-14 pb-6">
              {/* Online Ordering Button */}
              <div className="flex items-center flex-col sm:p-6 rounded-md shadow-lg mb-7">
                <button
                  onClick={handleOrderClick}
                  className="bg-[#df5742] hover:bg-[#c54937] text-white font-bold py-3 px-8 sm:px-12 rounded-lg text-base sm:text-lg transition-all duration-200 transform hover:scale-105 shadow-md w-full sm:w-auto"
                >
                  Passez vos commandes en ligne
                </button>
              </div>

              <div className="flex items-center flex-col bg-white p-3 rounded-md call-to-action-container mb-7">
                <h1 className="font-semibold text-xl sm:text-3xl text-center leading-tight first-heading">
                  Des bagels frais du jour
                </h1>
                <h1 className="font-semibold text-xl sm:text-3xl text-center leading-tight second-heading">
                  Livrés à votre porte
                </h1>
                <h1 className="font-semibold text-xl sm:text-3xl text-center leading-tight third-heading">
                  Abonnez-vous en 1 min!
                </h1>
              </div>

              <div className="flex items-center flex-col bg-white p-3 rounded-md call-to-action-container mb-7">
                <h2 className="text-2xl font-semibold text-[#df5742]">
                  Pemière livraison gratuite!
                </h2>
                <p className="text-base text-center">
                  Pour les 50 premiers abonnés de votre quartier
                </p>
              </div>

              <div className="flex text-center bg-white p-3 rounded-md  mb-7">
                Vous pourrez facilement sauter une livraison en textant "skip"
                ou vous désabonner en textant "désabonner"
              </div>

              <Form
                submitForm={submitForm}
                handleChange={handleChange}
                isSubmitting={isSubmitting}
                initialState={inputs}
                error={error}
                phoneNumberError={phoneNumberError}
              />
            </div>
            <div className="flex my-4 justify-between sm:flex-row flex-col">
              <div className="flex justify-center">
                <span
                  className="text-sm text-white cursor-pointer"
                  onClick={() => doShowUnsubscribeModal(true)}
                >
                  Souhaitez-vous vous&nbsp;
                  <span className="cursor-pointer font-semibold">
                    désabonner
                  </span>
                  ?
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* PWA Install Prompt */}
      {showInstallPrompt && (
        <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t-2 border-[#df5742] p-4 sm:p-6 z-50 animate-slide-up">
          <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <img
                src="/icon.png"
                alt="Bagels Round Top"
                className="w-12 h-12 rounded-lg"
              />
              <div>
                <h3 className="font-bold text-gray-800">Installer l'application</h3>
                <p className="text-sm text-gray-600">
                  Ajoutez Bagels Round Top à votre écran d'accueil
                </p>
              </div>
            </div>
            <div className="flex gap-3">
              <button
                onClick={handleDismissInstall}
                className="px-4 py-2 text-gray-600 hover:text-gray-800 font-semibold"
              >
                Plus tard
              </button>
              <button
                onClick={handleInstallClick}
                className="bg-[#df5742] hover:bg-[#c54937] text-white font-bold py-2 px-6 rounded-lg transition-all duration-200"
              >
                Installer
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Subscribe;
